import { isMobile } from "react-device-detect";
import { useMutation } from 'react-query';

const navigatorShare = async (linkDetails) => {
  return await navigator.share(linkDetails);
}

export const useNativeSharingModal = ({ onError }) => {
  const { isLoading, mutate } = useMutation(navigatorShare, { onError });
  const isMobileAndNativeSharingAvailable = isMobile && navigator.canShare;

  return { isLoading, openNativeSharingModal: mutate, isMobileAndNativeSharingAvailable };
}
